<template>
  <header class="main-header">
    <div class="burger menu-btn-one">
      <input type="checkbox" v-model="menuOpen" />
      <span></span>
      <span></span>
      <span></span>
    </div>

    <nav class="nav-links" :class="{ open: menuOpen }">
      <router-link to="/home">Home</router-link>
      <router-link to="/library" id="tour-biblioteca">Biblioteca</router-link>
      <!-- <router-link to="/academic">Acadêmico</router-link> -->
      <router-link to="/manage">Gerenciar Materiais</router-link>
    </nav>

    <div class="logo">
      <router-link to="/library">
        <img src="@/assets/logos/logo-branco.png" alt="Logo" />
      </router-link>
    </div>

    <nav class="nav-links-icon" :class="{ open: menuOpen }">
      <div id="tour-cart" style="display: flex;" v-if="!isSystemAdmin">
        <ShoppingCart ref="shoppingCart" />
      </div>

      <router-link to="/favorites" class="customize-link" title="Meus Favoritos">
        <i class="fa-solid fa-heart"></i>
      </router-link>

      <router-link v-if="isSystemAdmin" to="/admin/dashboard" class="customize-link" title="Painel Admin">
        <i class="fa-solid fa-gear"></i>
      </router-link>

      <router-link to="/customizeprofile" class="customize-link">
        <i class="fa-solid fa-brush"></i>
      </router-link>

      <div class="customize-link user-menu-wrapper" ref="userMenu" id="tour-profile">
        <a href="#" @click.prevent="toggleUserMenu">
          <i class="fa-solid fa-user"></i>
        </a>

        <div class="user-dropdown" v-show="userMenuOpen">
          <div class="dropdown-arrow"></div>
          <router-link :to="{ path: '/profile', query: { tab: 'dados' } }" @click="userMenuOpen = false">
            Meu Perfil
          </router-link>

          <router-link v-if="!isSystemAdmin" :to="{ path: '/profile', query: { tab: 'assinaturas' } }" @click="userMenuOpen = false">
            Compras
          </router-link>

          <!-- <router-link :to="{ path: '/profile', query: { tab: 'gerenciar' } }" @click="userMenuOpen = false">
            Gerenciar Materiais
          </router-link> -->
          <div class="divider"></div>
          <a href="#" @click.prevent="logout" class="logout-btn">Sair</a>
        </div>
      </div>

      <div class="customize-link">
        <a href="#" @click.prevent="startTour" title="Repetir Tutorial" style="color: #FEC401;">
          <i class="fa-solid fa-circle-question"></i>
        </a>
      </div>
    </nav>
  </header>
</template>

<script>
import "@/styles/Header.css";
import ShoppingCart from './ShoppingCart.vue';
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import { isSystemAdministrator } from "@/utils/permissions";

export default {
  name: "Header",
  components: {
    ShoppingCart
  },
  data() {
    return {
      menuOpen: false,
      userMenuOpen: false
    };
  },
  computed: {
    isSystemAdmin() {
      return isSystemAdministrator();
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    this.$emit('cart-ref', this.$refs.shoppingCart);

    if (!localStorage.getItem('tutorialSeen')) {
      setTimeout(() => {
        this.startTour();
        localStorage.setItem('tutorialSeen', 'true');
      }, 500);
    }
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    startTour() {
      const driverObj = driver({
        showProgress: true,
        nextBtnText: 'Próximo',
        prevBtnText: 'Anterior',
        doneBtnText: 'Concluir',
        steps: [
          {
            element: '#tour-biblioteca',
            popover: {
              title: 'Biblioteca',
              description: 'Espaço onde encontrará um acervo de disciplinas separadas em categorias',
              side: 'bottom',
              align: 'start'
            }
          },
          {
            element: '#tour-search',
            popover: {
              title: 'Pesquisa',
              description: 'Espaço onde pode pesquisar disciplinas, curso, materiais e tudo que precisar',
              side: 'bottom',
              align: 'start'
            }
          },
          {
            element: '#tour-cart',
            popover: {
              title: 'Carrinho',
              description: 'Espaço onde finalizará as compras e pagamento, assim podendo ter um histórico detalhado sobre suas compras',
              side: 'bottom',
              align: 'start'
            }
          },
          {
            element: '#tour-profile',
            popover: {
              title: 'Perfil',
              description: 'Espaço onde poderá ver o seu perfil, assim podendo alterar e manejar da melhor maneira possível',
              side: 'bottom',
              align: 'start'
            }
          }
        ]
      });
      driverObj.drive();
    },
    toggleUserMenu() {
      this.userMenuOpen = !this.userMenuOpen;
    },
    async logout() {
      this.userMenuOpen = false;
      localStorage.removeItem("token");
      window.location.href = "/";
    },
    handleClickOutside(event) {
      if (this.userMenuOpen && this.$refs.userMenu && !this.$refs.userMenu.contains(event.target)) {
        this.userMenuOpen = false;
      }
    }
  }
};
</script>